// extracted by mini-css-extract-plugin
export default {"root":"classes_root__6+IDx","comments":"classes_comments__C6MC0"};